// extracted by mini-css-extract-plugin
module.exports = {"footer":"styles_footer__1wEDf","content":"styles_content__2jACX","selectAll":"styles_selectAll__3kh5a"};